export default "__VITE_ASSET__CIrhs4aR__"